import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="combined-school-course-completion-test-applications"

export default class extends Controller {
  static targets = [ "switchFlag", "switchAreaField", "switchPlaceField" ]

  connect() {
    this.changeClassList(this.switchFlagTarget.value)
  }

  switchField(event) {
    this.changeClassList(event.target.value)
  }

  changeClassList(value) {
    if (value == 'web_exam') {
      this.switchAreaFieldTarget.parentElement.parentElement.classList.add('d-none')
      this.switchPlaceFieldTarget.parentElement.parentElement.classList.add('d-none')
    } else {
      this.switchAreaFieldTarget.parentElement.parentElement.classList.remove('d-none')
      this.switchPlaceFieldTarget.parentElement.parentElement.classList.remove('d-none')
    }
  }
}
